import functions from '../../functions';

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    const { RawHTML } = window.wp.element;
    
    const { 
        RichText,
        InspectorControls,
        InnerBlocks,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl,
            Toolbar,
        ToolbarButton,
        ToolbarGroup,
        SelectControl
    } = window.wp.components;

    registerBlockType('custom-gutenberg/highlight-text', {
        // built-in attributes
        title: 'Highlight text',
        description: 'Highlight text',
        icon: '',
        category: 'custom-containers',
        example: {},

        attributes: {
            title: {
                type: 'string',
                default: '',
            },
            icon: {
                type: 'string',
                default: 'heart-bed',
            },
        },

        // built-in functions
        edit({ attributes, setAttributes, className }) {

            const {
                title,
                icon,
                classes
            } = attributes;

            className = functions.getClassNames(className);
            if(classes != className) setAttributes({classes: className});

            return (
                [<InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody>
                        <p><strong>Title</strong></p>
                        <TextControl value={ title } onChange={title => setAttributes({ title })}></TextControl>
                        <p><strong>Icon</strong></p>
                        <TextControl value={ icon } onChange={icon => setAttributes({ icon })}></TextControl>
                    </PanelBody>
                </InspectorControls>,
                <div class="hightlight-note">
                    <div class="title-section">
                        <i class={icon}></i>
                        <div class="title">
                            { title }
                        </div>
                    </div>
                    <div class="content">
                        <InnerBlocks />
                    </div>
                </div> 
            ]
            );
        },

        save({ attributes }) {

            const {
                title,
                icon,
            } = attributes;

            return (
                <div className="hightlight-note">
                    <div className="title-section">
                        { icon && (
                            <i className={ icon }></i>
                        ) }
                        <div className="title">
                           { title }
                        </div>
                    </div>
                    <div className="content">
                        <InnerBlocks.Content />
                    </div>
                </div>
            );
        },
    });
}